import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";
import ItemView from "./ItemView";

export default class SpotView extends AbstractView {

    constructor(id, target) {
        super(target);

        this._lastClickTime = 0;
        
        //this._target.mouseChildren = false;
        this._target.gotoAndStop(0);
        this._id = id;
        this.reset();

        this._button = this.createButton(this._target.puddleButton);

        this._item = new ItemView(this._target.fish);
    }

    get button() {
        return this._button;
    }

    get target() {
        return this._target;
    }

    get id() {
        return this._id;
    }

    get item() {
        return this._item;
    }

    reset() {
    }

    canClick(cooldown = SpotView.DEFAULT_CLICK_COOLDOWN) {
        return new Date() - this.lastClickTime >= cooldown;
    }

    updateLastClickTime() {
        this.lastClickTime = new Date();
    }

    get lastClickTime() {
        return this._lastClickTime;
    }

    set lastClickTime(value) {
        this._lastClickTime = value;
    }

    destroy() {
        this._item.destroy();
        this._item = null;
    }
}

SpotView.DEFAULT_CLICK_COOLDOWN = 300;